<template>
  <modal @close="$emit('toggleShowMessagesModal')">
    <div slot="header">
      <h4>Send SMS to movers</h4>
    </div>

    <div slot="body"
         :class="'l-modal-body container'"
    >
      <div class="row mb-2">
        <div class="col-12 px-0">
          <div class="select-wrap">
            <label>SEND TO:</label>
            <simple-select v-model="selectedMover"
                           v-if="assignedMovers"
                           :options="assignedMovers"
                           label="full_name"
                           @input="getThread"
                           placeholder="Select Movers"
            />
          </div>
        </div>
      </div>

      <div class="row mb-4 scrollable">
        <template v-if="loadingMessages">
          <div class="col-12 px-0">
            <vue-content-loading :width="800" :height="250">
              <rect v-for="x in 3" :key="x" x="10" :y="15*x*4" rx="5" ry="5" width="720" height="26" />
            </vue-content-loading>
          </div>
        </template>
        <template v-else>
          <div class="col-12"
               v-for="message in thread"
               :key="message.id"
          >
            <template v-if="message.direction === 2">
              <div class="row">
                <div class="col-9 bg-primary rounded">
                  <p class="m-1 text-white">{{ message.body }}</p>
                </div>
                <div class="col-3" />
              </div>
              <div class="row mb-2">
                <div class="col">
                  <small class="m-1">{{ message.date }}</small>
                </div>
              </div>
            </template>
            <template v-else
                      class="m-1"
            >
              <div class="row">
                <div class="col-3" />
                <div class="col-9 bg-light rounded">
                  <p class="m-1">{{ message.body }}</p>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col text-right">
                  <small class="m-1">{{ message.date }}</small>
                </div>
              </div>
            </template>
          </div>
        </template>
      </div>
    </div>

    <div slot="footer">
      <div class="row notes-field bg-white">
        <div class="col-10 pr-0">
          <div class="border w-100 text-field text-field-sms d-flex align-items-center">
            <textarea v-auto-resize
                      ref="message"
                      class="px-3"
                      placeholder="Send SMS"
                      v-model="sms"
            />
          </div>
        </div>
        <div class="col-2 pl-0 pointer">
          <button class="btn btn-primary position-relative"
                  :disabled="!sms.length || loadingMessages"
                  @click="sendSms"
          >
            <span class="mod-icon-note" />
          </button>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col-12">
          <error-field :errors="errors" field="" />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <template v-if="!variablesLoaded">
            <div class="col-12 px-0">
              <vue-content-loading :width="800" :height="40">
                <rect x="10" :y="10" rx="5" ry="5" width="720" height="26" />
              </vue-content-loading>
            </div>
          </template>
          <template v-else>
            <div>
              <span class="badge badge-primary mx-1 unselectable pointer"
                    v-for="(variable, key, index) in modelVariables"
                    :key="index" @dblclick="insertVariable(variable)"
              >{{ key }}</span>
            </div>
          </template>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';
import Modal from '../../Modal';
import Errors from '../../../classes/Errors';

export default {
  components: {
    Modal,
  },
  props: {
    assignedMovers: {
      type: Array,
      default: null,
    },
    carrierId: {
      type: Number,
      default: null,
    },
    selectedMover: {
      type: [Object, Number],
      default: null,
    },
    carrierNumber: {
      type: [Number, String],
      default: null,
    },
    model: {
      type: [Object, String],
      default: null,
    },
    modelId: {
      type: Number,
      default: null,
    },
  },
  data: () => ({
    sms: '',
    thread: {},
    loadingButton: false,
    loadingMessages: false,
    modelVariables: {},
    variablesLoaded: false,
    errors: new Errors(),
  }),
  created() {
    this.assignedMovers.forEach(el => {
      el.full_name = `${el.first_name} ${el.last_name}`;
    });
    this.getThread();
  },
  methods: {
    sendSms() {
      this.loadingMessages = true;
      axios
        .post(`movers/text-messages`, {
          carrier_id: this.carrierId,
          job_id: this.modelId,
          mover_ids: [this.selectedMover],
          body: this.sms,
        })
        .then(() => {
          toastr.success('Message sent successfully');
          this.sms = '';
          this.getThread();
        })
        .catch(err => this.errors.record(err.response.data.error))
        .finally(() => {
          this.loadingMessages = false;
        });
    },
    getThread() {
      this.loadingMessages = true;
      axios
        .get(
          `movers/${this.selectedMover}/text-messages?carrier_phone_number=${this.carrierNumber}`,
        )
        .then(res => {
          this.thread = res.data.data;
          if (!this.variablesLoaded) {
            this.getVariables();
          }
        })
        .catch(err => this.errors.record(err.response.data.error))
        .finally(() => {
          this.loadingMessages = false;
        });
    },
    getVariables() {
      this.variablesLoaded = false;
      axios
        .get(`text-messages/${this.model}/${this.modelId}/values`)
        .then(res => {
          this.modelVariables = res.data;
        })
        .catch(err => this.errors.record(err.response.data.error))
        .finally(() => {
          this.variablesLoaded = true;
        });
    },
    insertVariable(variable) {
      const textarea = this.$refs.message;
      const cursorPosition = textarea.selectionStart;
      const textBefore = textarea.value.substring(0, cursorPosition);
      const textAfter = textarea.value.substring(cursorPosition, textarea.value.length);
      textarea.value = textBefore + variable + textAfter;
      if (textarea.setSelectionRange) {
        textarea.focus();
        textarea.setSelectionRange(
          cursorPosition + variable.length,
          cursorPosition + variable.length,
        );
      }
      this.sms = textarea.value;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/jobs/modals/Messages.vue